// libs/frontend/feature-public/src/lib/pages/layout/layout.component.ts

import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  LOCALE_ID,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { AuthStore } from '@front/frontend/data-access-auth/stores/auth.store';
import { BarraNavegacionComponent } from '@front/frontend/feature-public/components/dynamic/barra-navegacion/barra-navegacion.component';
import { BarraNavegacionService, ItemNavegacion } from '@front/frontend/feature-public/services/barra-navegacion.service';

@Component({
  selector: 'grafologia-layout',
  imports: [
    RouterOutlet,
    BarraNavegacionComponent
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit {
  #authStore = inject(AuthStore);
  #barraNavegacionService = inject(BarraNavegacionService);
  #destroyRef = inject(DestroyRef);
  locale = inject(LOCALE_ID)
  username = computed(() => this.#authStore.user()?.username);

  // Signals para la barra de navegación
  navItems = signal<ItemNavegacion[]>([]);
  comportamiento = signal<'fixed' | 'observer'>('fixed');
  seccionesObservadas = signal<string>('');
  paginaPrincipal = signal<string>('inicio');
  isLoadingNav = signal(true);

  ngOnInit(): void {
    this.loadBarraNavegacion();
  }

  private loadBarraNavegacion(): void {

    this.#barraNavegacionService.getPrimeraBarraNavegacion( { pageSize: 1, locale: this.locale } )
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
      next: (barra) => {
        if (barra) {
          this.navItems.set(barra.Componetizacion || []);
          this.comportamiento.set(barra.comportamiento || 'fixed');
          this.seccionesObservadas.set(barra.seccionesObservadas || '');
          this.paginaPrincipal.set(barra.PaginaPrincipal || 'inicio');
        } else {
          console.warn('⚠️ No se encontró ninguna barra de navegación');
        }

        this.isLoadingNav.set(false);
      },
      error: (error) => {
        console.error('❌ Error cargando barra de navegación:', error);
        this.isLoadingNav.set(false);
      }
    });
  }
}
